import * as React from 'react'
import { DestructuredURL, DVString, APIClient, safeBool, serializeFormdata, ItemPrerolls } from 'DVWebNodeUtils'
import { Icon, IconType } from '@amzn/dvui/dist/Icon'
import * as styles from './WatchlistStatus.module.scss'
import { Tooltip } from './Tooltip'
import { fireDraperTrackingEvent } from '../../DVWebNodeDraperPlayer/utils/metrics'
import * as cn from 'classnames'

interface WatchlistStatusProps {
  className?: string
  watchlistAction: watchlistEndpointResponseAction
  onToggle?: (newAction: watchlistEndpointResponseAction) => void
  prerolls?: ItemPrerolls
}

interface watchlistEndpointResponseAction {
  text: DVString
  tag: string
  endpoint: DestructuredURL
  ajaxEnabled: boolean
}

interface watchlistEndpointResponse {
  watchlistAction: watchlistEndpointResponseAction
}

const isAlreadyOnWatchlist = (watchlistTag: string) => watchlistTag.toLowerCase() == 'remove'

class WatchlistStatus extends React.Component<WatchlistStatusProps> {
  ajaxEnabled: boolean

  constructor(props: WatchlistStatusProps) {
    super(props)
    this.ajaxEnabled = props && props.watchlistAction &&
      safeBool(props.watchlistAction.ajaxEnabled)
    this.sendToggleRequest = this.sendToggleRequest.bind(this)
  }

  sendToggleRequest = (event: React.FormEvent<HTMLFormElement>) => {
    if (!this.ajaxEnabled) {
      return
    }
    event.preventDefault()
    const originalAction = this.props.watchlistAction
    const query = originalAction && originalAction.endpoint && originalAction.endpoint.query
    const partialURL = originalAction && originalAction.endpoint && originalAction.endpoint.partialURL
    const watchlistParams = serializeFormdata(query)
    const api = new APIClient
    api.call(partialURL, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'x-requested-with': 'XMLHttpRequest' // must be there for WPS not to do the redirect
      },
      body: watchlistParams
    }).then((json: watchlistEndpointResponse) => {
      const action = json.watchlistAction || false
      if (action && action.endpoint) {
        if (isAlreadyOnWatchlist(action.tag) && this.props.prerolls) {
          fireDraperTrackingEvent(this.props.prerolls, 'addToWatchlist')
        }
      }
      if (this.props.onToggle)
        this.props.onToggle(json.watchlistAction)

    })

    const active = document.activeElement as HTMLElement
    if (active)
      active.blur()
  }


  queryAsHiddenInputs(query: { [key: string]: string }) {
    const hiddenInputs = []
    for (const key in query) {
      if (query.hasOwnProperty(key)) {
        hiddenInputs.push(<input type="hidden" name={key} defaultValue={query[key]} key={key} />)
      }
    }
    return hiddenInputs
  }

  render() {
    const action = this.props.watchlistAction
    const endpoint = action && action.endpoint
    if (!(endpoint && endpoint.partialURL)) {
      return null
    }
    const ariaLabel = (action.text && action.text.string)
    const isOnWatchlist = isAlreadyOnWatchlist(action.tag)

    return (
      <Tooltip text={(action.text && action.text.string)}>

        <form className={styles.form} onSubmit={this.sendToggleRequest}
          action={endpoint && endpoint.partialURL} method="POST">
          {this.queryAsHiddenInputs(endpoint && endpoint.query)}
          <button type="submit"
            aria-label={ariaLabel}
            className={cn(styles.button, 'tst-watchlist-toggle')} >
            {(isOnWatchlist
              ? <Icon use={IconType.WATCHLIST_ON} className={this.props.className} />
              : <Icon use={IconType.ADD} className={this.props.className} />)
            }
          </button>
        </form>
      </Tooltip>
    )
  }
}
export default WatchlistStatus
